import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { updateAuth } from '../../actions/user';
import {
  BackArrow,
  Box,
  List,
  PageWithNavigation,
  SubscriptionHistoryItem,
  Title,
} from '../../components';
import { UserState } from '../../reducers/user';
import { RootState } from '../../reducers';
import './index.css';

const { api } = require('@cashew/utils');

const ns = 'sub-history';

/**
 * Orders Page RefundPage
 */
const Container = () => {
  const { t } = useTranslation();
  const params: any = useParams();
  const history = useHistory();
  const [subscriptionHistory, setSubscriptionHistory] = useState([]);
  const { language, token }: UserState = useSelector(
    (state: RootState) => state.user
  );
  api.storeAuth(token);
  const getInstallmentDetails = () => {
    api
      .get({
        endpoint: `products/options/${params.orderId}?paymentInfo=true`,
      })
      .then((resp: any) => {
        const { data } = resp;
        let subscriptionHistoryMap = data.subProducts[0].installments.filter(
          (item: any) => item?.status && item.status !== 'PENDING'
        );

        subscriptionHistoryMap = subscriptionHistoryMap.map((item: any) => ({
          ...item,
          currency: data.currencyCode,
          amount: item.installmentAmount,
        }));
        setSubscriptionHistory(subscriptionHistoryMap.slice().reverse());
      })
      .catch((resp: any) => {
        api.errorHandler({ resp, history });
      });
  };

  useEffect(() => {
    getInstallmentDetails();
  }, []);
  return (
    <div className={ns}>
      <Helmet>
        <title>{t('subscriptionHistory')}</title>
      </Helmet>
      <PageWithNavigation updateAuth={updateAuth}>
        <Title>
          {`Payment history ${params.orderId}`}
          <BackArrow
            to={`/${language}/subscriptions/${params.orderId}`}
            title="Back to subscription"
          />
        </Title>
        <Box className="sub-history__list">
          <header>
            <div>{t('Paid on')}</div>
            <div>{t('Amount paid')}</div>
            <div>{t('Status')}</div>
            <div>{t('Card used')}</div>
          </header>
          <List
            data={subscriptionHistory}
            component={SubscriptionHistoryItem}
            isLoading={false}
          />
        </Box>
      </PageWithNavigation>
    </div>
  );
};

export default Container;
